/**
 * Elopement APIs are keyed by roster client id. Dual-pin maps emit two pin
 * rows per client (`…-home` / `…-device`); the boundary selector must list
 * each person once.
 *
 * Prefer the home pin when both exist (stable label / residential identity).
 */
const LIVE_CLIENT_PIN_PREFIX = "live-client-";

/** Resolve the roster id used by elopement APIs from a pin or option row. */
export function rosterIdFromPin(pin) {
  if (!pin) return null;
  if (pin.clientId !== null && pin.clientId !== undefined && pin.clientId !== "") {
    return pin.clientId;
  }
  const id = pin.id;
  if (id === null || id === undefined || id === "") return null;
  if (typeof id === "string" && id.startsWith(LIVE_CLIENT_PIN_PREFIX)) {
    return id
      .slice(LIVE_CLIENT_PIN_PREFIX.length)
      .replace(/-(home|device)$/i, "");
  }
  return id;
}

export function elopementClientsFromPins(pins) {
  const byClient = new Map();
  if (!Array.isArray(pins)) return [];
  for (const pin of pins) {
    if (!pin) continue;
    const clientId = rosterIdFromPin(pin);
    if (clientId === null || clientId === undefined || clientId === "") {
      continue;
    }
    const key = String(clientId);
    const existing = byClient.get(key);
    if (!existing || pin.sourceKind === "home") {
      byClient.set(key, {
        id: clientId,
        name: pin.name || pin.label || `Client ${clientId}`,
      });
    }
  }
  return Array.from(byClient.values());
}
